Ext.define('SA.view.ImportFileStepErrorWindow', {
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-import-file-step-error-window',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    items: [
        {
            xtype: 'component',
            cls: 'sa-import-file-step-error-window-body',
            itemId: 'body',

            tpl: [
                '<svg class="sa-import-file-step-error-window-warning-svg"><use href="#sa-icon-warning"></use></svg>',
                '<div class="sa-import-file-step-error-window-message">',
                    '<strong>Please correct the following error(s) to continue:</strong>',
                    '<ul class="sa-import-file-step-error-window-error-list">',
                        '<tpl if="hasNoFiles() || hasUnitWithoutFile()">',
                            '<li>File fields can’t be empty.</li>',
                        '</tpl>',
                        '<tpl if="hasFileWithoutUnit()">',
                            '<li>Geographic units must be selected.</li>',
                        '</tpl>',
                        '<tpl if="hasDuplicateUnits()">',
                            '<li>Any geographic unit can only be used for one file.</li>',
                        '</tpl>',
                        '<tpl if="hasDifferentColumnCountsAcrossFiles()">',
                            '<li>All files must have the same number of columns.</li>',
                        '</tpl>',
                        '<tpl if="hasFileWithMoreThanOneUniqueHeaderName()">',
                            '<li>All files must either a) share the same header names, or b) have only one uniquely named header.</li>',
                        '</tpl>',
                        '<tpl for="getNamesOfUnreadableFiles()">',
                            '<li>The file <strong>‘{.:htmlEncode}’</strong> could not be read. (You may need to reselect it.)</li>',
                        '</tpl>',
                        '<tpl for="getValidatorsForInvalidFiles()">',
                            '<tpl if="hasBlankHeaderName()">',
                                '<li>The file <strong>‘{fileName:htmlEncode}’</strong> has a blank header name.</li>',
                            '</tpl>',
                            '<tpl if="hasDuplicateHeaderName()">',
                                '<li>The file <strong>‘{fileName:htmlEncode}’</strong> has repeated header names.</li>',
                            '</tpl>',
                            '<tpl if="hasNoDataRows()">',
                                '<li>The file <strong>‘{fileName:htmlEncode}’</strong> must have at least one row of data.</li>',
                            '</tpl>',
                            '<tpl if="hasSingleColumn()">',
                                '<li>The file <strong>‘{fileName:htmlEncode}’</strong> must have at least two columns.</li>',
                            '</tpl>',
                            '<tpl if="hasInconsistentColumnCount()">',
                                '<li>The file <strong>‘{fileName:htmlEncode}’</strong> has rows with an inconsistent number of columns.</li>',
                            '</tpl>',
                        '</tpl>',
                        '<tpl if="hasBlankDatasetName()">',
                            '<li>A dataset name is required.</li>',
                        '</tpl>',
                        '<tpl if="hasDuplicateDatasetName()">',
                            '<li>The dataset name must be unique.</li>',
                        '</tpl>',
                    '</ul>',
                '</div>'
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-import-file-step-error-window-footer',

            items: [{
                xtype: 'sa-button',
                itemId: 'okBtn',
                text: 'OK',
                ui: 'primary',
                width: 75
            }]
        }
    ],

    initComponent() {
        this.callParent();

        this.down('#body').update(this.validator);
    },

    initEvents() {
        this.callParent();

        this.down('#okBtn').on('click', this.destroy, this);
    }
});